import { useState } from "react";
import { api, apiError } from "@/api";

const INTERESTS = [
  "Attending events",
  "DJ opportunities",
  "Artist opportunities",
  "Volunteering",
  "Partnerships",
  "ANKHARA Radio",
];

export default function JoinForm({ onDone }) {
  const [form, setForm] = useState({ email: "", first_name: "", city: "", interests: [], consent: false, website: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const toggleInterest = (i) =>
    setForm((f) => ({
      ...f,
      interests: f.interests.includes(i) ? f.interests.filter((x) => x !== i) : [...f.interests, i],
    }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.consent) {
      setError("Please confirm you'd like to receive ANKHARA emails.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/subscribe", form);
      try { window.posthog?.capture("email_signup_complete"); } catch {}
      setSuccess(true);
      onDone?.();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (success) {
    return (
      <div className="ank-success" data-testid="join-success">
        <p className="ank-success-title">YOU'RE IN THE ROOT SYSTEM.</p>
        <p className="ank-modal-copy">Watch your inbox for the next transmission.</p>
      </div>
    );
  }

  return (
    <form className="ank-form" onSubmit={submit} data-testid="join-form">
      <input
        type="text"
        name="website"
        value={form.website}
        onChange={(e) => setForm({ ...form, website: e.target.value })}
        className="ank-honeypot"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />
      <div className="ank-field">
        <label htmlFor="join-email">EMAIL ADDRESS *</label>
        <input
          id="join-email"
          data-testid="join-email-input"
          type="email"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="you@example.com"
        />
      </div>
      <div className="ank-field-row">
        <div className="ank-field">
          <label htmlFor="join-name">FIRST NAME</label>
          <input
            id="join-name"
            data-testid="join-name-input"
            type="text"
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
          />
        </div>
        <div className="ank-field">
          <label htmlFor="join-city">CITY</label>
          <input
            id="join-city"
            data-testid="join-city-input"
            type="text"
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
          />
        </div>
      </div>
      <div className="ank-field">
        <label>INTERESTS (OPTIONAL)</label>
        <div className="ank-interests" data-testid="join-interests">
          {INTERESTS.map((i) => (
            <button
              key={i}
              type="button"
              className={`ank-chip ${form.interests.includes(i) ? "on" : ""}`}
              data-testid={`join-interest-${i.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => toggleInterest(i)}
            >
              {i.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
      <label className="ank-check" data-testid="join-consent">
        <input
          type="checkbox"
          checked={form.consent}
          onChange={(e) => setForm({ ...form, consent: e.target.checked })}
        />
        <span>
          Yes — email me ANKHARA sessions, open calls, mixes and invitations. I can unsubscribe
          anytime with one click, and my address is never shared.
        </span>
      </label>
      {error && <p className="ank-form-error" data-testid="join-error">{error}</p>}
      <button type="submit" className="ank-submit" disabled={busy} data-testid="join-submit-btn">
        {busy ? "TRANSMITTING…" : "JOIN THE ROOT SYSTEM"}
      </button>
    </form>
  );
}
